import React, {Component} from 'react';
import { connect } from "react-redux";
import { Modal } from 'antd-mobile';
import InsFormText from "../../components/InsFormText";
import Divider from "../../components/Divider";
import InsFormTitle from "../../components/InsFormTitle";
import ShowDetail from "../../components/ShowDetail";
import IdentityAuthenticationFailed from '../../components/IdentityAuthenticationFailed';

interface Props {
}

interface State {
    showDetail: boolean;
    isIdentityAuthenticationFailed: boolean;
}

class Text extends Component <Props, State> {
	constructor(props) {
		super(props);
		this.showDetail = this.showDetail.bind(this);
		this.state = {
            showDetail: true,
            isIdentityAuthenticationFailed:true
        };
        this.closeIdentityAuthenticationFailed = this.closeIdentityAuthenticationFailed.bind(this);
	}

	showDetail() {
		this.setState({
			showDetail: false
		});
    }
    
    closeIdentityAuthenticationFailed = () => {
        this.setState({
			isIdentityAuthenticationFailed: false
		});
    }

	render() {
		return (
			<div>
				<InsFormTitle title={"车辆&车主信息"}/>
				<div style={{paddingLeft: "0.3rem", paddingRight: "0.3rem"}}>
					<InsFormText height={"0.6rem"} leftText="左边文字" rightText="右边文字"/>
					<Divider/>
					<InsFormText height={"0.6rem"} leftText="左边文字" rightText="右边文字" rightSize={"0.3rem"}
					             rightBold={true} rightColor={"#000"}/>
					<Divider/>
					<InsFormText leftText="左边文字" rightText="右边文字" leftBold={true} leftColor={"#000"}
					             leftSize={"0.3rem"}/>
				</div>
				<Divider/>
                <ShowDetail show={this.state.showDetail} showDetail={this.showDetail} />
                {
                    this.state.isIdentityAuthenticationFailed ? <IdentityAuthenticationFailed url='https://testapp.szia.org.cn/dualRecord/view/h5/loading.html?key=833C065F242BB89FEDEC5266459AA752' onClose={this.closeIdentityAuthenticationFailed}/> : null
                }
			</div>
		)
	}

}

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = (dispatch: any) => ({});
export default connect(mapStateToProps, mapDispatchToProps)(Text);

